export const GET_ASSURED_GIFTS_DATA = 'GET_ASSURED_GIFTS_DATA';
export const GET_ASSURED_GIFTS_DATA_SUCCESS = 'GET_ASSURED_GIFTS_DATA_SUCCESS';
export const GET_ASSURED_GIFTS_DATA_ERROR = 'GET_ASSURED_GIFTS_DATA_ERROR';
